/*
 * useMqtt — subscribes to all SmartPatch topics and returns live state
 */
import { useState, useEffect, useRef } from 'react';
import { getClient, TOPICS } from '../mqttClient';

const ECG_MAX_POINTS = 200;

export default function useMqtt() {
  const [connected, setConnected]   = useState(false);
  const [ecgData,   setEcgData]     = useState([]);
  const [hr,        setHr]          = useState(null);
  const [spo2,      setSpo2]        = useState(null);
  const [temp,      setTemp]        = useState(null);
  const [motion,    setMotion]      = useState(null);
  const [alert,     setAlert]       = useState({ level: 'OK', msg: '' });
  const [auth,      setAuth]        = useState({ status: 'PENDING' });

  const ecgRef = useRef([]);

  useEffect(() => {
    const client = getClient();

    const onConnect = () => setConnected(true);
    const onClose   = () => setConnected(false);

    const onMessage = (topic, payload) => {
      let data;
      try { data = JSON.parse(payload.toString()); }
      catch { return; }

      switch (topic) {
        case TOPICS.ECG: {
          const point = { t: data.t ?? Date.now(), v: data.v ?? 0 };
          ecgRef.current = [...ecgRef.current, point].slice(-ECG_MAX_POINTS);
          setEcgData([...ecgRef.current]);
          break;
        }
        case TOPICS.HR:
          setHr(data.bpm);
          break;
        case TOPICS.SPO2:
          setSpo2(data.pct);
          break;
        case TOPICS.TEMP:
          setTemp(data.degC);
          break;
        case TOPICS.MOTION:
          setMotion(data);
          break;
        case TOPICS.ALERT:
          setAlert({ level: data.level, msg: data.msg });
          break;
        case TOPICS.AUTH:
          setAuth({ status: data.status });
          break;
        default:
          break;
      }
    };

    client.on('connect', onConnect);
    client.on('close',   onClose);
    client.on('message', onMessage);

    // Sync initial connected state
    if (client.connected) setConnected(true);

    return () => {
      client.off('connect', onConnect);
      client.off('close',   onClose);
      client.off('message', onMessage);
    };
  }, []);

  return { connected, ecgData, hr, spo2, temp, motion, alert, auth };
}
